import React from "react";
import { Helmet } from "react-helmet-async";
import DefaultViewer from "./DefaultViewer";
import AiResearchViewer from "./AiResearchViewer";
import SampleViewer from "./SampleViewer";
import { popPdfViewerHideDownloadButton } from "utils/helper/localStorage";

const PdfjsViewer: React.FunctionComponent = () => {
  const searchParams = new URLSearchParams(location.search);
  // AIリサーチ画面から遷移してきた場合、researchKeyPdfクエリパラメータが存在する
  const researchKeyPdf = searchParams.get("researchKeyPdf");
  // サンプルPDFを閲覧する場合、sampleUrlクエリパラメータにPDFのURLが入る
  const sampleUrl = searchParams.get("sampleUrl");
  const hideDownloadButtonNonce = searchParams.get("hideDownloadButtonNonce");
  // 呼び出し元がPDFのダウンロードボタンを非表示にしたい場合、download() や
  // EventFilter の handleViewSamplePdf が window.open する前に
  // localStorage へフラグを設定している
  const hideDownloadButton = popPdfViewerHideDownloadButton(
    hideDownloadButtonNonce ?? undefined
  );

  return (
    <>
      <Helmet>
        <title>日経バリューサーチ</title>
      </Helmet>
      {researchKeyPdf ? (
        <AiResearchViewer researchKeyPdf={researchKeyPdf} />
      ) : sampleUrl ? (
        <SampleViewer src={sampleUrl} hideDownloadButton={hideDownloadButton} />
      ) : (
        <DefaultViewer hideDownloadButton={hideDownloadButton} />
      )}
    </>
  );
};

export default PdfjsViewer;
